import React from "react";
import Lottie from "lottie-react";
import arrowRightDrawnLottie from "../assets/lottie/arrow-right-drawn.json";
import { Fade, Zoom } from "react-awesome-reveal";
import ReactiveButton from "reactive-button";
import {
  AiOutlineInstagram,
  AiOutlineLinkedin,
  AiOutlineGithub,
} from "react-icons/ai";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import { useGSAP } from "@gsap/react";
import AboutContent from "./AboutContent";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(MotionPathPlugin);

const rx = window.innerWidth < 1000 ? window.innerWidth / 1200 : 1;
const ry = window.innerHeight < 700 ? window.innerHeight / 1200 : 1;

const path = [
  { x: 0, y: 30 },
  { x: 0, y: 30 },
  { x: 0, y: 30 },
  { x: 0, y: 30 },
];

const scaledPath = path.map(({ x, y }) => ({
  x: x * rx,
  y: y * ry,
}));

function MobileAbout() {
  // useGSAP(() => {
  //   const tl = gsap.timeline({
  //     scrollTrigger: {
  //       scrub: 1.5,
  //       start: () => "top top",
  //       end: () => "+=" + window.innerHeight * 3,
  //     },
  //   });

  //   tl.to("#profile", {
  //     motionPath: {
  //       path: scaledPath,
  //       align: "self",
  //       alignOrigin: [0.5, 0.5],
  //     },
  //     duration: 8,
  //     immediateRender: true,
  //   });

  //   tl.to(".indicator", { opacity: 0 }, 0);
  //   tl.to("#profile", { opacity: 0 }, "-=6");
  //   tl.to(".about-content", { opacity: 1 }, "-=6");
  //   tl.to(".about-content", { opacity: 0 }, "-=1");

  //   const lights = [...document.querySelectorAll("[dataLights]")];
  //   const lightsTl = gsap.timeline({
  //     scrollTrigger: {
  //       scrub: 6,
  //     },
  //   });

  //   lightsTl.from(
  //     lights[0],
  //     {
  //       x: window.innerWidth * -1,
  //       y: window.innerHeight,
  //       ease: "power4.out",
  //       duration: 80,
  //     },
  //     0
  //   );

  //   lightsTl.to(
  //     lights[0],
  //     {
  //       x: window.innerWidth,
  //       y: window.innerHeight * -1,
  //       ease: "power4.out",
  //       duration: 80,
  //     },
  //     "-=5"
  //   );
  // }, {});

  return (
    <div className="about-shell mobile-about-shell">
      {/* <div className="lights">
        <div className="lights__group" dataLights="1">
          <div className="lights__light"></div>
          <div className="lights__light"></div>
          <div className="lights__light"></div>
          <div className="lights__light"></div>
          <div className="lights__light"></div>
          <div className="lights__light"></div>
          <div className="lights__light"></div>
          <div className="lights__light"></div>
        </div>
      </div> */}

      <div className="hero-shell">
        <div className="about-profile" id="profile">
          <img src="/img/myprofile.png" alt="my profile" />
        </div>

        <div className="hie-container">
          <Fade delay={2000}>
            <h1 className="role">Hi! I Am</h1>
          </Fade>
          <Zoom delay={2600}>
            <h1 className="role hero-name">
              Siddaiah M<span>.</span>
            </h1>
          </Zoom>
        </div>

          <Zoom delay={2600}>
        <div className="mobile-hero-badge">
          <span>Senior Software Engineer</span>
          <span>React • React Native • Node.js</span>
        </div>
          </Zoom>

        <div className="hire-me-container">
          <Zoom delay={3000}>
            <Lottie animationData={arrowRightDrawnLottie} className="arrow-anim" loop={true} />
          </Zoom>
          <Zoom delay={3000}>
            <ReactiveButton
              onClick={() => {
                window.open("https://www.linkedin.com/in/siddaiahm/", "_blank");
              }}
              key={1}
              rounded
              shadow
              color="yellow"
              idleText="Wanna Chat?"
            />
          </Zoom>
        </div>

        <div className="social-container">
          <Fade direction="up" delay={3000}>
            <a href="https://www.instagram.com/_the_fascinating_mortal_/" rel="noreferrer" target="_blank">
              <AiOutlineInstagram className="social-icon" />
            </a>
            <a href="https://www.linkedin.com/in/siddaiahm/" rel="noreferrer" target="_blank">
              <AiOutlineLinkedin className="social-icon" />
            </a>
            <a href="https://github.com/siddaiahm" rel="noreferrer" target="_blank">
              <AiOutlineGithub className="social-icon" />
            </a>
          </Fade>
        </div>
      </div>

      <AboutContent />
    </div>
  );
}

export default MobileAbout;
